import React, { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Container, Row, Col, Button, Form, FormGroup, Input, Label, Alert } from "reactstrap";
import AuthService from "../services/authService";

const ResetPassword = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const onChangeNewPassword = (e) => {
        setNewPassword(e.target.value);
    };

    const onChangeConfirmPassword = (e) => {
        setConfirmPassword(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setMessage("");
        setError("");

        // Validate passwords match
        if (newPassword !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        // Validate password strength
        if (newPassword.length < 8) {
            setError("Password must be at least 8 characters long");
            return;
        }

        setLoading(true);

        try {
            await AuthService.confirmPasswordReset(token, newPassword, confirmPassword);
            setSuccess(true);
            setMessage('Your password has been successfully reset. You can now log in with your new password.');
            
            // Redirect to login after 3 seconds
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (err) {
            const errorMessage = err.response?.data?.message || 
                               err.response?.data?.error || 
                               'Failed to reset password. The reset link may have expired.';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
            <Row className="w-100">
                <Col md={{ size: 6, offset: 3 }}>
                    <div className="border rounded p-4 bg-light">
                        <h2 className="text-center mb-4">Reset Password</h2>
                        <p className="text-center text-muted mb-4">
                            Enter your new password below.
                        </p>
                        
                        <Form onSubmit={handleSubmit}>
                            <FormGroup>
                                <Label for="newPassword">New Password</Label>
                                <Input
                                    type="password"
                                    name="newPassword"
                                    id="newPassword"
                                    placeholder="Enter new password"
                                    value={newPassword}
                                    onChange={onChangeNewPassword}
                                    required
                                    disabled={success}
                                    minLength={8}
                                />
                                <small className="text-muted">
                                    Password must be at least 8 characters long
                                </small>
                            </FormGroup>

                            <FormGroup>
                                <Label for="confirmPassword">Confirm Password</Label>
                                <Input
                                    type="password"
                                    name="confirmPassword"
                                    id="confirmPassword"
                                    placeholder="Confirm new password"
                                    value={confirmPassword}
                                    onChange={onChangeConfirmPassword}
                                    required
                                    disabled={success}
                                    minLength={8}
                                />
                            </FormGroup>

                            {error && (
                                <Alert color="danger">
                                    {error}
                                </Alert>
                            )}

                            {message && (
                                <Alert color="success">
                                    {message}
                                    {success && (
                                        <div className="mt-2">
                                            Redirecting to login page...
                                        </div>
                                    )}
                                </Alert>
                            )}

                            {!success && (
                                <Button 
                                    color="primary" 
                                    block 
                                    disabled={loading || !newPassword || !confirmPassword}
                                >
                                    {loading ? 'Resetting Password...' : 'Reset Password'}
                                </Button>
                            )}

                            <div className="text-center mt-3">
                                <Link to="/login">Back to Login</Link>
                            </div>
                        </Form>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default ResetPassword;
